/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */

import MessageHelper from './message-helper';

export default class ParsleyHelper {

  static setParsleyGlobalOptions(): void {
    this.addCustomValidators();

    window.Parsley.options.errorsWrapper = '<ul class="form-group__validation parsley-errors-list"></ul>';
    window.Parsley.options.errorsContainer = (parsleyField: any): JQuery => {
      const parent = parsleyField.$element.parent() as JQuery;
      const closestInputGroup = parent.closest('.form-group');

      if (closestInputGroup.length) {
        return closestInputGroup;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return parsleyField.$element;
    };
  }

  static addCustomValidators(): void {
    window.Parsley.addValidator('filesize', {
      requirementType: 'integer',
      validate: function validate(value, requirement, parsleyInstance) {
        const file = (parsleyInstance.$element[0] as HTMLInputElement).files;
        const maxBytes = requirement * 1024 * 1024;

        const result = $.Deferred<string>();

        if (file === null || !file.length || file.length === 0) {
          result.resolve(); // eslint-disable-line @typescript-eslint/no-floating-promises
        }

        if (file?.length === 1 && file[0].size <= maxBytes) {
          return result.resolve();
        }

        return result.reject(MessageHelper.getMessage('eparts.validation.filemaxsize')
          .replace('{0}', requirement));
      },
    });

    window.Parsley.addValidator('exactlength', {

      validate: function validate(value, requirement, parsleyInstance) {

        const result = $.Deferred<string>();

        if (parsleyInstance.$element[0].value.length === requirement) {
          return result.resolve();
        }

        return result.reject(MessageHelper.getMessage('eparts.validation.exactlength')
          .replace('{0}', requirement));
      },
    });

    window.Parsley.addValidator('rangelength', {
      validate: function validate(value, requirement, parsleyInstance) {
        const result = $.Deferred<string>();

        if (requirement.split(',')[0] <= parsleyInstance.$element[0].value.length
          && parsleyInstance.$element[0].value.length <= requirement.split(',')[1]
        ) {
          return result.resolve();
        }

        return result.reject(
          MessageHelper.getMessage('eparts.validation.rangelength')
            .replace('{0}', requirement.split(',')[0])
            .replace('{1}', requirement.split(',')[1]),
        );
      },
    });

    const parseRequirement = (requirement) => (Number.isNaN(+requirement) ? parseFloat($(requirement)
      .val() as string) : +requirement);

    // Less than or null to validator
    window.Parsley.addValidator('lessthannotnull', {
      validate: function validate(value, requirement) {

        const result = $.Deferred<string>();

        if (!parseRequirement(requirement) || parseFloat(value) < parseRequirement(requirement)) {
          return result.resolve();
        }
        return result.reject(MessageHelper.getMessage('eparts.validation.lessthannotnull')
          .replace('{0}', parseRequirement(requirement)
            .toString()));
      },
    });

    // Textarea max length validation
    window.Parsley.addValidator('textareamaxlength', {
      validate: function validate(value, requirement, parsleyInstance) {
        const result = $.Deferred<string>();

        if (parsleyInstance.$element[0].value.replace(/\r(?!\n)|\n(?!\r)/g, '\r\n').length <= parseRequirement(requirement)) {
          return result.resolve();
        }

        return result.reject(MessageHelper.getMessage('eparts.validation.textareamaxlength')
          .replace('{0}', parseRequirement(requirement)
            .toString()));

      },

    });
  }
}
